import HalfPriceTraffic from "@components/HalfPriceTraffic";
import Close from "assets/svg/close.svg";
import Play from "assets/svg/play.svg";
import Head from "next/head";
import React, { FC, useState } from "react";
import { toAbsoluteUrl } from "src/utils/seo";

import Modal from "../Modal";

type Props = {
  url: string;
  name?: string;
  description?: string;
  date?: string;
  isSchema?: boolean;
  canonical?: string;
};

const Video: FC<Props> = ({
  url,
  name,
  date,
  description,
  isSchema = false,
  canonical,
}) => {
  const [isShowVideoModal, setIsShowVideoModal] = useState(false);
  return (
    <>
      {isSchema && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: `{
                      "@context": "https://schema.org",
                      "@type": "VideoObject",
                      "mainEntityOfPage": "${toAbsoluteUrl(canonical)}",
                      "uploadDate": "${date ?? Date.now()}",
                      "duration": "",
                      "name": "${(name as string)?.replace(/"/g, " ")}",
                      "description": "${
                        (description as string)?.replace(/"/g, " ") ?? ""
                      }",
                      "thumbnailUrl": "https://dadbanan.com/images/default-video-thumbnail.jpg",
                      "contentUrl": "${url}",
                      "publisher": {
                        "@type": "Organization",
                        "name": "ویدیوی دادبانان",
                        "logo": {
                          "@type": "ImageObject",
                          "url": "https://dadbanan.com/images/default-video-thumbnail.jpg",
                          "width": 98,
                          "height": 30
                        }
                      },
                      "sameAs" : [
                        "https://t.me/dadbanandanalawfirm/3388",
                        "https://twitter.com/FDadbanan?s=12",
                        "https://www.instagram.com/dadbanan",
                        "https://www.linkedin.com/company/dadbanan"
                      ]
                    }`,
            }}
          />
        </Head>
      )}
      <Modal
        visible={isShowVideoModal}
        onClose={() => setIsShowVideoModal(false)}
        className="h-screen w-screen"
      >
        <div className="relative mx-auto h-60 w-10/12 rounded bg-black md:h-96 md:w-8/12 xl:h-190">
          <video controls src={url} className="h-full w-full" />
          <Close
            onClick={() => setIsShowVideoModal(false)}
            className="absolute top-5 left-5 cursor-pointer fill-white"
          />
          <HalfPriceTraffic
            classes="absolute top-[1rem] right-[1rem] z-50 rounded"
            type="VIDEO"
            spaces="pr-2 md:pr-4 !ml-2"
            text="هزینه اینترنت مصرفی : نیم‌بها"
          />
        </div>
      </Modal>
      <div
        className={`w-full bg-transparent py-5 transition-all md:rounded lg:h-[572px]`}
        style={{
          contain: "content",
        }}
      >
        <div
          className={`relative h-full transition-all`}
          style={{ contain: "content" }}
        >
          <div className="relative flex h-80 w-full md:h-96 md:rounded xl:h-full">
            <div
              className="absolute top-0 h-full w-full px-6 py-5 text-white md:rounded md:p-5"
              style={{
                background:
                  "linear-gradient(269.74deg, rgba(54, 100, 148, 0.9) 0.22%, rgba(4, 128, 212, 0.9) 52.6%, rgba(39, 178, 188, 0.9) 99.79%)",
              }}
            >
              <div className="flex h-full w-full flex-col justify-between gap-x-2 lg:flex-row">
                <div className="mx-auto flex h-auto flex-col justify-center text-center xl:h-full 2xl:w-1/4">
                  <span className="mb-5 text-lg 2xl:text-[22px]">
                    نمونه ویدئو آموزشی دوره
                  </span>
                  <p className="mb-3 text-sm">{name}</p>
                </div>
                <div className="relative flex h-52 w-full max-w-[60%] items-center justify-center rounded md:h-[77%] xl:h-full">
                  <video src={url} className="h-full w-full rounded-lg" />
                  <Play
                    onClick={() => setIsShowVideoModal(true)}
                    className="absolute top-1/2 left-1/2 h-16 w-16 -translate-y-1/2 -translate-x-1/2 cursor-pointer drop-shadow-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Video;
